import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ArrowForwardSharpIcon from "@mui/icons-material/ArrowForwardSharp";
import vision1 from "../../assets/Landing/vision/vision1.jpg";
import ButtonBase from "@mui/material/ButtonBase";
import { Button } from "@mui/material";
import sb1 from "../../assets/Landing/vision/sb.png";
import bg1 from "../../assets/Landing/backgroundImages/i-bg1.jpg";

const userTestimonials = [
  {
    name: "Coorperation",
    testimonial:
      "We work with our customers to help provide them with the best solution",
    backgroundColor: "#fff",
  },
  {
    name: "Creativity",
    testimonial:
      "We continue to innovate and provide users with customized technology and solutions",
    backgroundColor: "blue",
    color: "white",
  },
  {
    name: "Reliability",
    testimonial:
      "We deliver on our promise to make customers feel comfortable and satisfied",
    backgroundImage: vision1,
    color: "white",
  },
  {
    name: "Integrity",
    testimonial:
      "Ethics and integrity are the foundation of our brand and the guiding principles of Reseltech",
    backgroundColor: "#00336a",
    color: "white",
  },
];

const visionTestimonials = [
  {
    number: "100",
    sub: "+",
    testimonial: "Success rate of current cooperation projects",
  },
  {
    number: "200",
    sub: "+",
    testimonial: "Successful application of oil Wells in globally",
  },
  {
    number: <span style={{ color: "blue" }}> AICD & AICV</span>,
    //sup: <img src={sb1} alt="sb1" />,
    testimonial: "Core oil and water control technology",
  },
  {
    number: "20",
    sub: "+",
    testimonial: "Patents",
  },
];

export default function OurMission() {
  return (
    <Box
      id="testimonials"
      sx={{
        backgroundImage: `url(${bg1})`, // Add the path to your background image
        backgroundSize: "cover",
        backgroundPosition: "center",
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        padding: "1%",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "70%" },
          textAlign: { xs: "center", sm: "center", md: "center" },
        }}
      >
        <Typography sx={{ fontSize: "44px" }}>OUR MISSION</Typography>

        <Typography sx={{ fontSize: "24px" }}>
          Through the continuous innovation of technology and services, help
          users improve oil recovery and win-win with users.
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: "flex" }}>
            <ButtonBase
              sx={{
                display: "block",
                textDecoration: "none", // Remove underline from the button
                borderRadius: "8px", // Add border radius to match Card appearance
              }}
              onClick={() => {
                // Handle button click event here
              }}
            >
              <Card
                sx={{
                  maxWidth: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  pt: { xs: 4, sm: 12 },
                  pb: { xs: 8, sm: 12 },
                  p: 1,
                  backgroundColor: testimonial.backgroundColor, // Set background color to transparent

                  backgroundImage: `url(${testimonial.backgroundImage})`, // Set the background image
                  backgroundRepeat: "no-repeat", // Prevent background image from repeating
                  backgroundSize: "cover", // Adjust background size to cover the entire card,
                  color: testimonial.color,
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    pr: 2,
                  }}
                >
                  <CardHeader title={testimonial.name} />
                  <CardContent>
                    <Typography>{testimonial.testimonial}</Typography>
                  </CardContent>
                  <ArrowForwardSharpIcon color="white" />
                </Box>
              </Card>
            </ButtonBase>
          </Grid>
        ))}
      </Grid>
      <Box
        sx={{
          width: { sm: "100%", md: "90%" },
          textAlign: { xs: "center", sm: "center", md: "center" },
        }}
      >
        <Typography sx={{ fontSize: "44px" }}>OUR VISION</Typography>
        <Typography sx={{ fontSize: "24px" }}>
          Become an oil and gas field technology service provider with the
          world's leading technology, so that users can be satisfied and all
          employees and partners can obtain material and spiritual happiness
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {visionTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={3} key={index} sx={{ display: "flex" }}>
            <Box
              sx={{
                maxWidth: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
                pt: { xs: 4, sm: 12 },
                pb: { xs: 8, sm: 12 },
                p: 1,

                backgroundImage: `url(${testimonial.backgroundImage})`, // Set the background image
                backgroundRepeat: "no-repeat", // Prevent background image from repeating
                backgroundSize: "cover", // Adjust background size to cover the entire card,
                color: testimonial.color,
                border: "2px solid blue",
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  pr: 2,
                  fontSize: "40px",
                }}
              >
                <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
                  <Typography variant="h6">
                    <b style={{ fontSize: "40px" }}>{testimonial.number}</b>{" "}
                    <sub>{testimonial.sub}</sub>
                    <sup>{testimonial.sup}</sup>
                  </Typography>
                </Box>
                <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
                  <Typography>
                    <b>{testimonial.testimonial}</b>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid item xs={12}>
          <Box sx={{ textAlign: "center", pt: 4, pb: 4 }}>
            <Button variant="contained" sx={{ width: "130px" }}>
              More
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
